/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOtherSystemSourceInput
 */
export interface CreateOtherSystemSourceInput {
    /**
     * 
     * @type {string}
     * @memberof CreateOtherSystemSourceInput
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherSystemSourceInput
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherSystemSourceInput
     */
    domainId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOtherSystemSourceInput
     */
    centreId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOtherSystemSourceInput
     */
    includeInMarketingCosts?: boolean | null;
}

/**
 * Check if a given object implements the CreateOtherSystemSourceInput interface.
 */
export function instanceOfCreateOtherSystemSourceInput(value: object): value is CreateOtherSystemSourceInput {
    return true;
}

export function CreateOtherSystemSourceInputFromJSON(json: any): CreateOtherSystemSourceInput {
    return CreateOtherSystemSourceInputFromJSONTyped(json, false);
}

export function CreateOtherSystemSourceInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOtherSystemSourceInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'category': json['category'] == null ? undefined : json['category'],
        'domainId': json['domainId'] == null ? undefined : json['domainId'],
        'centreId': json['centreId'] == null ? undefined : json['centreId'],
        'includeInMarketingCosts': json['includeInMarketingCosts'] === undefined ? undefined : json['includeInMarketingCosts'] === null ? null : json['includeInMarketingCosts'],
    };
}

export function CreateOtherSystemSourceInputToJSON(json: any): CreateOtherSystemSourceInput {
    return CreateOtherSystemSourceInputToJSONTyped(json, false);
}

export function CreateOtherSystemSourceInputToJSONTyped(value?: CreateOtherSystemSourceInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'category': value['category'],
        'domainId': value['domainId'],
        'centreId': value['centreId'],
        'includeInMarketingCosts': value['includeInMarketingCosts'],
    };
}

